import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { orderAssignmentConfirmUploadDocumentAction } from '_models/redux/confirm-upload-assignment-document/action';
import { cleanOrderAssignmentConfirmUploadDocument } from '_models/redux/confirm-upload-assignment-document/clean-action';
import { orderAssignmentCreateUrlDocumentAction } from '_models/redux/create-url-upload-assignment-document/action';
import { cleanOrderAssignmentCreateUrlDocument } from '_models/redux/create-url-upload-assignment-document/clean-action';
import { getOrderAssignmentDetail } from '_models/redux/get-order-detail/action';
import { cleanOrderAssignmentDetail } from '_models/redux/get-order-detail/clean-action';
import { removeAssignmentDocumentAction } from '_models/redux/remove-assignment-document/action';
import { cleanRemoveAssignmentDocument } from '_models/redux/remove-assignment-document/clean-action';
import { updateOrderLineAssignmentAction } from '_models/redux/update-order-line-assignment/action';
import { cleanUpdateOrderLineAssignment } from '_models/redux/update-order-line-assignment/clean-action';
import { orderAssignmentUploadDocumentAction } from '_models/redux/upload-assignment-document/action';
import { cleanOrderAssignmentUploadDocument } from '_models/redux/upload-assignment-document/clean-action';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import { ElectronicDocuments } from '../components/ElectronicDocuments';
import { LegalRepresentativeForm } from '../components/LegalRepresentativeForm';
import { TaxDataForm } from '../components/TaxDataForm';
import { useAssignmentOrder } from '../hooks/useAssignmentOrder';

const AssignmentsOrderPage = ({
  orderAssignmentDetail,
  getOrderAssignmentDetail,
  cleanOrderAssignmentDetail,
  updateOrderLineAssignment,
  updateOrderLineAssignmentAction,
  cleanUpdateOrderLineAssignment,
  orderAssignmentCreateUrlDocument,
  orderAssignmentCreateUrlDocumentAction,
  cleanOrderAssignmentCreateUrlDocument,
  orderAssignmentUploadDocument,
  orderAssignmentUploadDocumentAction,
  cleanOrderAssignmentUploadDocument,
  orderAssignmentConfirmUploadDocument,
  orderAssignmentConfirmUploadDocumentAction,
  cleanOrderAssignmentConfirmUploadDocument,
  removeAssignmentDocument,
  removeAssignmentDocumentAction,
  cleanRemoveAssignmentDocument,
}) => {
  const {
    navigateToSearchPage,
    register,
    errors,
    taxDataValidations,
    handleSubmitTaxData,
    isDialogOpen,
    dialogMessage,
    dialogTitleMessage,
    handleClose,
    createUrl,
    removeDocument,
    isLoadingDocument,
    selectedFilesByDocument,
    activeTypeDocumentId,
    activeDocumentAction,
    pendingFileName,
    documentId,
    isLoading,
    setValue,
    uploadedDocuments,
    areRequiredDocumentsLoaded,
    isTermsAccepted,
    setIsTermsAccepted,
  } = useAssignmentOrder({
    orderAssignmentDetail,
    getOrderAssignmentDetail,
    cleanOrderAssignmentDetail,
    updateOrderLineAssignment,
    updateOrderLineAssignmentAction,
    cleanUpdateOrderLineAssignment,
    orderAssignmentCreateUrlDocument,
    orderAssignmentCreateUrlDocumentAction,
    cleanOrderAssignmentCreateUrlDocument,
    orderAssignmentUploadDocument,
    orderAssignmentUploadDocumentAction,
    cleanOrderAssignmentUploadDocument,
    orderAssignmentConfirmUploadDocument,
    orderAssignmentConfirmUploadDocumentAction,
    cleanOrderAssignmentConfirmUploadDocument,
    removeAssignmentDocument,
    removeAssignmentDocumentAction,
    cleanRemoveAssignmentDocument,
  });

  return (
    <>
      <Box component='form' id='tax-data-form' onSubmit={handleSubmitTaxData}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <IconButton onClick={navigateToSearchPage} sx={{ mr: 1 }} aria-label='Regresar'>
            <ArrowBackIosIcon fontSize='small' />
          </IconButton>
          <Typography component='h4' variant='h6'>
            Nueva orden de vinculación
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {isLoading ? (
            <Box
              width={'80rem'}
              height={'30rem'}
              alignContent={'center'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Grid container size={{ xs: 12, sm: 12, md: 6 }} spacing={4}>
                <TaxDataForm
                  register={register}
                  errors={errors}
                  taxDataValidations={taxDataValidations}
                  setValue={setValue}
                />
                <LegalRepresentativeForm
                  register={register}
                  errors={errors}
                  taxDataValidations={taxDataValidations}
                  setValue={setValue}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                <ElectronicDocuments
                  createUrl={createUrl}
                  removeDocument={removeDocument}
                  isLoadingDocument={isLoadingDocument}
                  selectedFilesByDocument={selectedFilesByDocument}
                  activeTypeDocumentId={activeTypeDocumentId}
                  activeDocumentAction={activeDocumentAction}
                  pendingFileName={pendingFileName}
                  documentId={documentId}
                  uploadedDocuments={uploadedDocuments}
                  isTermsAccepted={isTermsAccepted}
                  setIsTermsAccepted={setIsTermsAccepted}
                />
                <Button
                  fullWidth
                  type='submit'
                  form='tax-data-form'
                  variant='contained'
                  sx={{ mt: 3, backgroundColor: '#6c39d2' }}
                  disabled={isLoading || !areRequiredDocumentsLoaded || !isTermsAccepted}
                >
                  Continuar
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      <CustomDialog
        title={dialogTitleMessage}
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  orderAssignmentDetail: state.orderAssignmentDetail,
  updateOrderLineAssignment: state.updateOrderLineAssignment,
  orderAssignmentCreateUrlDocument: state.orderAssignmentCreateUrlDocument,
  orderAssignmentUploadDocument: state.orderAssignmentUploadDocument,
  orderAssignmentConfirmUploadDocument: state.orderAssignmentConfirmUploadDocument,
  removeAssignmentDocument: state.removeAssignmentDocument,
});

const mapDispatchToProps = {
  getOrderAssignmentDetail,
  cleanOrderAssignmentDetail,
  updateOrderLineAssignmentAction,
  cleanUpdateOrderLineAssignment,
  orderAssignmentCreateUrlDocumentAction,
  cleanOrderAssignmentCreateUrlDocument,
  orderAssignmentUploadDocumentAction,
  cleanOrderAssignmentUploadDocument,
  orderAssignmentConfirmUploadDocumentAction,
  cleanOrderAssignmentConfirmUploadDocument,
  removeAssignmentDocumentAction,
  cleanRemoveAssignmentDocument,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsOrderPage);
